/*
Copyright (c) 2012-2022 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { camelCase } from "lodash"
import { Middleware } from "redux"
import update from "immutability-helper"
import { AppState } from "../store.type"

export const mockFailedResponseMiddleware: Middleware<
  {},
  AppState
> = store => next => async action => {
  // example: http://localhost:9090/food/menu/{merchantID}#mockfailed
  const isFlagEnabled = window.location.hash.split("#").includes("mockfailed")

  if (!action?.mockFailedResponse || !isFlagEnabled) {
    return next(action)
  }

  if (action.type.endsWith("_SUCCESS") || action.type.endsWith("_FAIL")) {
    return next(action)
  }

  const isAxiosRequest = action.payload && action.payload.request
  if (!isAxiosRequest) {
    return next(action)
  }

  const operation = `${camelCase(action.type)}Failed`

  let data = {}
  try {
    // eslint-disable-next-line import/no-dynamic-require
    data = require(`tests/mock-responses/${operation}.json`)
  } catch (error) {
    data = {} // For eslint...
  }

  const mockAction = update(action, {
    payload: {
      request: { $set: undefined }, // Remove the request object to disable axios middleware
    },
  })
  next(mockAction)

  const mockFailed = {
    ...action,
    payload: { request: undefined },
    type: `${action.type}_FAIL`,
    error: data,
    meta: {
      previousAction: action,
    },
  }

  store.dispatch(mockFailed) // Remove the request object to disable axios middleware

  return mockFailed
}
